<viz-header title={{title}} [brandLink]="brandLink">

  <div *ngIf="(isAuthenticated$ | async) === false; else authenticated">
    <mat-tab-group (selectedTabChange)="redirect($event)">
      <mat-tab label="Domains"></mat-tab>
      <mat-tab label="Login"> </mat-tab>
    </mat-tab-group>
  </div>
  <ng-template #authenticated>
    <!-- <viz-nav-menu icon="home" id="iconHome">
      <viz-nav-menu-item routerLink="/" displayText="Home" id="menuHomeHome"></viz-nav-menu-item>
    </viz-nav-menu>
    <viz-nav-menu icon="help" id="iconHelp">
      <viz-nav-menu-item routerLink="apis/supporthelp" displayText="Support Help" id="menuHelpSupport"></viz-nav-menu-item>
      <viz-nav-menu-item routerLink="apis/subscribetodep" displayText="Subscribe to DEP" id="menuHelpSubscribe"></viz-nav-menu-item>
    </viz-nav-menu>
    <viz-nav-menu icon="notifications" id="iconNotification">
      <viz-nav-menu-item routerLink="apis/notifications" displayText="Notifications" id="menuNotificationNotifications"></viz-nav-menu-item>
    </viz-nav-menu>
    <div #alert>
      <viz-nav-menu icon="apps" id="iconApps" (click)="openAlertDialog()"></viz-nav-menu>
    </div> -->
    <viz-nav-menu icon="person" id="iconPerson">
      <viz-nav-menu-item routerLink="/" [userName]="(userName$ | async)" id="menuPersonLoggedIn"></viz-nav-menu-item>
      <!-- <viz-nav-menu-item routerLink="app/profile-settings" [state]="{index: 0}" displayText="Profile" id="menuPersonProfile"></viz-nav-menu-item> -->
      <viz-nav-menu-item routerLink="app/dashboard" displayText="Dashboard" id="menuPersonDashboard"></viz-nav-menu-item>
      <viz-nav-menu-item routerLink="app/schedules" displayText="Schedules" id="menuPersonSchedules"></viz-nav-menu-item>
      <viz-nav-menu-item routerLink="app/my-notifications" displayText="My Notifications" id="menuPersonNotifications"></viz-nav-menu-item>
      <!-- <viz-nav-menu-item routerLink="app/profile-settings/subscriptions" [state]="{index: 1}" displayText="Manage Subscription" id="menuPersonSubscription"></viz-nav-menu-item> -->
      <!-- <viz-nav-menu-item routerLink="app/filtercontrols" displayText="Filter Controls" id="menuPersonFilterControls"></viz-nav-menu-item> -->
      <viz-nav-menu-item routerLink="app/member-storage-accounts" displayText="Member Storage Accounts" id="menuPersonMemberStorageAccounts"></viz-nav-menu-item>
      <viz-nav-menu-item routerLink="/" (click)="logout()" displayText="Log out" id="menuPersonLogout"></viz-nav-menu-item>
    </viz-nav-menu>
  </ng-template>
</viz-header>
